import { Segment } from '@/types';

export const removeOrderNumberProperty = ({ orderNumber, ...rest }: any) =>
  rest;
